var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDeployedIcon = function SvgDeployedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.60931 11.1381L10.276 6.4714C10.5363 6.21105 10.5363 5.78894 10.276 5.52859L5.60931 0.861923L4.6665 1.80473L8.86177 5.99999L4.6665 10.1953L5.60931 11.1381Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.60931 11.1381L6.27598 6.4714C6.53633 6.21105 6.53633 5.78894 6.27598 5.52859L1.60931 0.861923L0.666504 1.80473L4.86177 5.99999L0.666504 10.1953L1.60931 11.1381Z",
    fill: "white"
  })));
};
export { SvgDeployedIcon as ReactComponent };
export default __webpack_public_path__ + "assets/c2a00d10.svg";